"use client";

import { forwardRef } from "react";
import Avatar from "@mui/material/Avatar";
import PersonOutlineIcon from "@mui/icons-material/PersonOutlineOutlined";
import { cleanName } from "@/lib/utils/nameUtils";

export function getProfileInitials(name) {
  const words = cleanName(typeof name === "string" ? name : "")
    .split(/\s+/)
    .filter(Boolean);
  const first = Array.from(words[0] || "")[0] || "";
  const last = words.length > 1 ? Array.from(words.at(-1))[0] : "";
  return `${first}${last}`.toLocaleUpperCase();
}

const ProfileAvatar = forwardRef(function ProfileAvatar(
  { name = "", alt, sx, ...props },
  ref,
) {
  const initials = getProfileInitials(name);
  return (
    <Avatar
      role="img"
      aria-label={alt || name || "Profile"}
      {...props}
      ref={ref}
      alt={alt || name || "Profile"}
      sx={[
        {
          bgcolor: (theme) =>
            theme.palette.mode === "dark"
              ? theme.palette.grey[800]
              : theme.palette.grey[200],
          color: "text.primary",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {initials ? (
        <svg width="100%" height="100%" viewBox="0 0 100 100" aria-hidden="true">
          <text
            x="50"
            y="50"
            dy=".35em"
            textAnchor="middle"
            fill="currentColor"
            fontFamily="inherit"
            fontSize="38"
            fontWeight="600"
          >
            {initials}
          </text>
        </svg>
      ) : (
        <PersonOutlineIcon sx={{ width: "52%", height: "52%" }} aria-hidden />
      )}
    </Avatar>
  );
});

export default ProfileAvatar;
